module.exports = __webpack_public_path__ + "v294910/img/佣金.2453dccb.png";